export default {
	name: 'sign-in',
	data: () => ({
		password: ''
	}),
	computed: {
		defaultPassword: {
			get: () => 'Schoolastic@2018'
		},
		konamiCodePattern: {
			get: () => '38,38,40,40,37,39,37,39,66,65'
		}
	},
	methods: {
		signIn() {

			if (this.password === this.defaultPassword) {

				this.$router.push({
					name: 'Dashboard'
				});

			}
		},
		konamiCode() {

			let keys = [];

			window.addEventListener('keydown', (event) => {

				keys.push(event.keyCode);

				if (keys.toString().indexOf(this.konamiCodePattern) >= 0) {

					this.$router.push({
						name: 'Dashboard'
					});

					keys = [];

				}

			}, true);

		}
	},
	created() {

		this.konamiCode();

	}
};



// WEBPACK FOOTER //
// ./sources/app/sign-in/index.js